import { render, staticRenderFns } from "./AdministratorForma.vue?vue&type=template&id=7e1808f6&scoped=true&"
import script from "./AdministratorForma.vue?vue&type=script&lang=js&"
export * from "./AdministratorForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1808f6",
  null
  
)

export default component.exports